<template>
  <div class="shop_list">
    <el-form :inline="true" :model="goodsParams" size="small">
      <el-form-item label="商品ID：" required>
        <el-input v-model="goodsParams.id" placeholder="请输入商品ID" />
      </el-form-item>
      <el-form-item label="商品名称：" required>
        <el-input
          v-model="goodsParams.name"
          placeholder="请输入商品名称"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="queryTableList()"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh-right" @click="resetParams()"
          >重置</el-button
        >
        <el-button type="success" size="small" @click="next()"
          >下一步</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableGoodsList"
      border
      style="width: 100%"
      ref="singleTable"
      height="68vh"
      empty-text="请先在上方输入加盟店名称进行查询商品"
      :header-cell-style="{
        background: '#f0f0f0',
        color: '#000',
      }"
      @current-change="handleCurrentChange1"
      highlight-current-row
    >
      <el-table-column label="单选" width="70" align="center">
        <template slot-scope="scope">
          <el-radio
            v-model="productId"
            :label="scope.row.id"
            @change="handleRadioChange(scope.row)"
            class="custom-radio-cell"
            >&nbsp;</el-radio
          >
        </template>
      </el-table-column>
      <el-table-column align="center" label="序号" type="index" width="90" />
      <el-table-column align="center" label="商品ID" prop="id" width="120" />
      <el-table-column
        align="center"
        label="商品名称"
        prop="name"
        width="220"
        show-overflow-tooltip
      />
      <el-table-column align="center" label="开售状态" width="180">
        <template slot-scope="scope">
          {{ $dict.canBuyStatus | dictFormat(scope.row.canBuy) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品图片" width="180">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.imageUrl"
            :preview-src-list="[scope.row.imageUrl]"
            class="img"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="上传时间"
        prop="createdAt"
        width="220"
      />
      <el-table-column
        align="center"
        label="更新时间"
        prop="updatedAt"
        width="220"
      />
    </el-table>

    <el-pagination
      :current-page="goodsParams.pageNo"
      :page-size="goodsParams.pageSize"
      :page-sizes="[10, 20, 30]"
      :total="total"
      background
      layout="total, sizes,prev, pager, next,jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getGoodsList } from "@/assets/api/aiProduct";
export default {
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableGoodsList: [],
      productId: "",
      total: 0,
      currentRow: {}, //选中行
      // 商品列表查询参数
      goodsParams: {
        pageNo: 1,
        pageSize: 10,
        id: "",
        name: "",
        slProductTypeName: "",
      },
    };
  },
  mounted() {
    this.queryTableList();
  },
  methods: {
    // 处理单选按钮变化
    handleRadioChange(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    // 选中商品
    handleCurrentChange1(val) {
      this.productId = val.id;
      this.currentRow = val;
    },
    // 查询商品
    queryTableList() {
      this.listLoading = true;
      getGoodsList(this.goodsParams).then((res) => {
        if (res.code == 200) {
          this.tableGoodsList = res.data.list;
          this.total = Number(res.data.total);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    resetParams() {
      Object.keys(this.goodsParams).map(item=>{
          this.goodsParams[item]=''
      })
      this.goodsParams.pageNo=1
      this.goodsParams.pageSize=10
      this.queryTableList()
},
    next() {
      if (!this.currentRow.id) {
        this.$message.warning("请先选择商品");
        return
      }
      console.log(this.currentRow);
      
      if (!this.currentRow.aiVideoUrl) {
        if (this.currentRow.processStepStatus == 2) {
          this.$message.warning("该商品已生成视频，如需修改，请直接修改即可。");
        } else if(this.currentRow.processStepStatus == 3) {
          this.$message.warning("该商品在队列中排队生成，请耐心等待");
        }else{
            this.$emit("addGoods", this.currentRow);
        }
      } else {
        this.$emit("addGoods", this.currentRow);
      }
    },
    handleSizeChange(val) {
      this.goodsParams.pageSize = val;
      this.goodsParams.pageNo = 1;
      this.queryTableList();
    },
    handleCurrentChange(val) {
      this.goodsParams.pageNo = val;
      this.queryTableList();
    },
  },
};
</script>

<style scoped>
/* 重置浏览器默认样式 */
.img {
  width: 100px;
  height: 100px;
}
</style>
